import axios from '@common/backend/axios';

const BASE = '';

export interface ILoginData {
	email: string;
	password: string;
}
export const login = (data: ILoginData) => axios.post(`${BASE}/login`, data);
export const stuffLogin = (data: ILoginData) => axios.post(`${BASE}/staff/login`, data);

export const refresh = async () => axios.get('/refresh-token') as Promise<ImpersonateResponse>;

export interface IRegisterData {
	first_name: string;
	last_name: string;
	email: string;
	password?: string;
	phone?: string;
	test_id?: number;
	test_location_id?: number;
	tags?: string[];
	service_ids?: number[];
}

export type PartnerRegisterPayload = {
	first_name: string;
	last_name: string;
	email: string;
	phone?: string;
	is_talented?: boolean;
};

export const register = (data: IRegisterData) =>
	axios.post(`${BASE}/register`, {
		...data,
		password_confirmation: data.password,
	});

export interface IResetPasswordData {
	email: string;
}
export const resetPassword = (data: IResetPasswordData) =>
	axios.post(`${BASE}/reset-password`, data);

export interface IResetPasswordTokenData {
	password: string;
	password_confirmation: string;
}
export const resetPasswordToken = (token: string, data: IResetPasswordTokenData) =>
	axios.patch(`${BASE}/reset-password/${token}`, data);

export interface ImpersonateResponse {
	code: number;
	token: string;
}

export const getImpersonateToken = async (id: number) =>
	axios.get(`/impersonate/${id}`) as Promise<ImpersonateResponse>;

export const verifyEmail = async () => axios.post(`${BASE}/verify-email`);

export const getAccessToken = ({ accessToken }: { accessToken: string }) =>
	axios.post('/login/byAccessToken', { access_token: accessToken }) as Promise<ImpersonateResponse>;

export const registerPartner = (payload: PartnerRegisterPayload) =>
	axios.post('/partners', payload);
